'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = diffStyle;
/**
 * diffs a style object against a base style object
 *
 * @param {Object} style - style object which is diffed
 * @param {Object?} base - base style object
 */
function diffStyle(style) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(style).reduce(function (diff, property) {
    var value = style[property];
    // recursive object iteration in order to render
    // pseudo class and media class declarations
    if (value instanceof Object && !Array.isArray(value)) {
      var nestedDiff = diffStyle(value, base[property]);
      if (Object.keys(nestedDiff).length > 0) {
        diff[property] = nestedDiff;
      }
    } else {
      // diff styles with the base styles to only extract dynamic styles
      if (value !== undefined && base[property] !== value) {
        // remove concatenated string values including `undefined`
        if (typeof value === 'string' && value.indexOf('undefined') > -1) {
          return diff;
        }
        diff[property] = value;
      }
    }
    return diff;
  }, {});
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/diffStyle.js
// module id = 440
// module chunks = 0